import React, { FC } from 'react';
import './presenter-slide-notification.scss';
import { observer } from 'mobx-react';
import { useStore } from '../../../store/store-provider';

const PresenterSlideNotification: FC = (): JSX.Element | null => {
  const { slideManagementStore } = useStore();
  const { isShowSlideAdvancingPopUp, forceCloseSlideNotification, lastUserNameModifyTheSlides } = slideManagementStore;
  return (
    <>
      {isShowSlideAdvancingPopUp()
        ?
          <div className='slide-notification'>
            <div className='slide-notification__content'>
              <div className='slide-notification__body'>
                <div className='slide-notification__body__info'>
                  {`${lastUserNameModifyTheSlides} is advancing the slides.`}
                </div>
                <div className='close-notification-btn' onClick={forceCloseSlideNotification}/>
              </div>
            </div>
          </div>
        : null
      }
    </>
  );
};

export default observer(PresenterSlideNotification);